import { combineReducers } from 'redux';

import dataReducer from './dataReducer';
import homeReducer from './homeReducer';
import agencyReducer from './agencyReducer';
import datasetReducer from './datasetReducer';
import categoryReducer from './categoryReducer';
import typeReducer from './typeReducer';
import tagReducer from './tagReducer';
import fileReducer from './fileReducer';
import infoGraphicReducer from './infoGraphicReducer';
import kritikSaranReducer from './kritikSaranReducer';

const reducer = combineReducers({
    dataReducer,
    homeReducer,
    agencyReducer,
    datasetReducer,
    categoryReducer,
    typeReducer,
    tagReducer,
    fileReducer,
    infoGraphicReducer,
    kritikSaranReducer
});

export default reducer;